import React from "react";

const Bookmark = (width = 24, height = 24) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <g>
        <g>
          <path
            fill="#fff"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.5 0h5A2.451 2.451 0 0 1 10 2.4V12L5 8.4 0 12V2.4A2.451 2.451 0 0 1 2.5 0z"
            transform="translate(-579 -615) translate(586 621)"
          />
        </g>
        <path
          fill="none"
          d="M0 0H24V24H0z"
          transform="translate(-579 -615) translate(579 615)"
        />
      </g>
    </svg>
  );
};

export default Bookmark;
